// Vendor imports
const _ = require('lodash')
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const deferDispatch = require('client-v2/common/state/dispatch')
// Entry imports
const searchFormActions = require('./actions')
const SearchForm = require('./component-dumb')
const searchFormSelectors = require('./selectors')

const FETCH_SUGGESTIONS_THROTTLED_FREQUENCY = 100 // ms

function mapStateToProps(state) {
  const { searchForm } = state
  if (!searchForm) {
    return { isVisible: false }
  }
  return {
    isVisible: searchForm.isVisible,
    suggestions: searchFormSelectors.suggestions(state),
    value: searchForm.value
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)

  const fetchSuggestionsThrottled = _.throttle(
    value => dispatch(searchFormActions.fetchSuggestions(value)),
    FETCH_SUGGESTIONS_THROTTLED_FREQUENCY
  )

  function onChange(value) {
    dispatch(searchFormActions.setValue(value))
    fetchSuggestionsThrottled(value)
  }

  return {
    onChange,
    onReset: dispatchAction(searchFormActions.reset),
    onSubmit: dispatchAction(searchFormActions.submit)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    SearchForm
  )
)
